import { Suspense, Fragment, lazy } from "react"
import { Switch, Route } from "react-router-dom"
import humps from "humps"

import Loader from "./components/Loader/Loader"
import AdminLayout from "./layouts/AdminLayout"

import GuestGuard from "./components/Auth/GuestGuard"
import AuthGuard from "./components/Auth/AuthGuard"
import AllRoutes from "./routes/AllRoutes"
import { RoutePaths } from "./routes/RoutePaths"
import { getUserRole } from "./assets/js/app/state/appSessionStorage"

export const renderRoutes = (routes = []) => {
  let allowedRoutes = getAllowedRoutes(routes)
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        {allowedRoutes.map((route, i) => {
          const Guard = route.guard || Fragment
          const Layout = route.layout || Fragment
          const Component = route.component
          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          )
        })}
      </Switch>
    </Suspense>
  )
}

function isArrayWithLength(arr) {
  return (Array.isArray(arr) && arr.length)
}

export function getAllowedRoutes(routes) {
  // eslint-disable-next-line no-undef
  const role = humps.camelize(getUserRole() ? getUserRole() : "")
  const finalRoutes = routes.filter((route) => {
    const allowRoute = route.permission?.includes(role) || route.permission?.includes("*")
    if(!route.permission) return true
    else if(!isArrayWithLength(route.permission)) return true
    else return allowRoute
  })
  return finalRoutes
}

const routes = [
  {
    exact: true,
    guard: GuestGuard,
    permission: ["*"],
    path: RoutePaths.SIGN_IN,
    component: lazy(() => import("./assets/js/pages/login/LoginPage"))
  },
  {
    exact: true,
    guard: GuestGuard,
    permission: ["*"],
    path: RoutePaths.TENANT_SIGN_IN,
    component: lazy(() => import("./assets/js/pages/login/LoginPage"))
  },
  {
    path: "*",
    layout: AdminLayout,
    guard: AuthGuard,
    permission: ["*"],
    routes: AllRoutes()
  }
]

export default routes
